import { AppBar, Toolbar, IconButton, Hidden, Box } from "@mui/material";
import { Logout, Menu } from "@mui/icons-material";
import { FC, Fragment, useState } from "react";
import useAuth from "src/hooks/useAuth";
import PropTypes from "prop-types";
import AlertDialog from "./AlertDialog";
import { DRAWER_WIDTH } from "src/utils/constants";
import BoldTypography from "./BoldTypography";
import { Link } from "react-router-dom";

interface NavBarProps {
  onOpenSidebar: () => void;
}

const NavBar: FC<NavBarProps> = ({ onOpenSidebar }) => {
  const { signOutFB } = useAuth();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenSignOutDialog = (): void => {
    setIsDialogOpen(true);
  };

  const handleCloseSignOutDialog = (): void => {
    setIsDialogOpen(false);
  };

  const handleSignOut = (): void => {
    signOutFB();
    handleCloseSignOutDialog();
  };

  return (
    <Fragment>
      <AppBar
        sx={{
          width: { lg: `calc(100% - ${DRAWER_WIDTH}px)` },
          ml: { lg: DRAWER_WIDTH / 8 },
        }}
      >
        <Toolbar>
          <Hidden lgUp>
            <IconButton
              onClick={onOpenSidebar}
              size="large"
              edge="start"
              color="inherit"
            >
              <Menu />
            </IconButton>
            <Box component={Link} to="/" sx={{ textDecoration: "none", ml: 2 }}>
              <BoldTypography variant="h6" color="white">
                RECOVA
              </BoldTypography>
            </Box>
          </Hidden>
          <Box flexGrow={1} />
          <IconButton
            edge="end"
            color="inherit"
            size="large"
            onClick={handleOpenSignOutDialog}
          >
            <Logout />
          </IconButton>
        </Toolbar>
      </AppBar>
      <AlertDialog
        open={isDialogOpen}
        title="Sign out"
        message="Are you sure to sign out ?"
        onClose={handleCloseSignOutDialog}
        onSubmit={handleSignOut}
      />
    </Fragment>
  );
};

NavBar.propTypes = {
  onOpenSidebar: PropTypes.func.isRequired,
};

export default NavBar;
